import { create } from 'zustand';
import api from 'src/services/api';

interface User {
  id: string;
  email: string;
  role: string;
  tenant_id: string;
  job_title_id?: string;
  name?: string;
  full_name?: string;
  avatar_url?: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (credentials: URLSearchParams) => Promise<void>;
  logout: () => void;
  initialize: () => void;
  updateUser: (userData: Partial<User>) => void;
}

const useAuthStore = create<AuthState>()((set) => ({
  user: JSON.parse(localStorage.getItem('mentisra_user') || 'null'),
  token: localStorage.getItem('mentisra_token'),
  isAuthenticated: !!localStorage.getItem('mentisra_token'),
  isLoading: false,

  login: async (credentials: URLSearchParams) => {
    set({ isLoading: true });
    try {
      const response = await api.post('/auth/login', credentials, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });

      const { access_token, user } = response.data;

      localStorage.setItem('mentisra_token', access_token);
      localStorage.setItem('mentisra_user', JSON.stringify(user));
      localStorage.setItem('mentisra_tenant_id', user.tenant_id);
      localStorage.removeItem('sidebar_open_states');

      set({
        token: access_token,
        user,
        isAuthenticated: true,
        isLoading: false
      });
    } catch (error) {
      set({ isLoading: false });
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('mentisra_token');
    localStorage.removeItem('mentisra_user');
    localStorage.removeItem('mentisra_tenant_id');
    localStorage.removeItem('sidebar_open_states');
    set({
      token: null,
      user: null,
      isAuthenticated: false
    });
  },

  initialize: () => {
    const token = localStorage.getItem('mentisra_token');
    const user = JSON.parse(localStorage.getItem('mentisra_user') || 'null');
    if (token && user) {
      set({ token, user, isAuthenticated: true });
    }
  },

  updateUser: (userData: Partial<User>) => {
    set((state) => {
      if (state.user) {
        const updatedUser = { ...state.user, ...userData };
        localStorage.setItem('mentisra_user', JSON.stringify(updatedUser));
        return { user: updatedUser };
      }
      return state;
    });
  }
}));

export default useAuthStore;
